import { useState, useCallback } from "react";
import { deleteSectionsToDocumentsURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export function useDeleteSection(token, section, refresh, close) {
  const [loading, setLoading] = useState(false);

  const handleDelete = useCallback(async () => {
    if (!section?.ID_SECCION) return;

    setLoading(true);
    try {
      const res = await fetch(
        `${deleteSectionsToDocumentsURL()}?id_section=${section.ID_SECCION}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!res.ok) {
        toastAlert("Error al eliminar la sección", "error");
        setLoading(false);
        return;
      }
      refresh();
      toastAlert("Sección eliminada correctamente", "success");
      close();
    } catch (err) {
      toastAlert("Error al eliminar la sección: " + err.message, "error");
    } finally {
      setLoading(false);
    }
  }, [token, section, refresh, close]);

  return { loading, handleDelete };
}
